var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-highlights"},[_c('div',{staticClass:"c-highlights--loaded"},[(_vm.listFull)?_c('FlightTeaser',{attrs:{"flightLists":_vm.flightList,"dateFormat":_vm.dateFormat,"timeFormat":_vm.timeFormat}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }